import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchPermissions } from "./permissionsService";

const initialState = {
    userPermissions: [],
    status: 'idle',  // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null
};

export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserPermissions.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.userPermissions = action.payload;
            })
            .addCase(fetchUserPermissions.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })            
            .addCase(fetchUserPermissions.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});


export const fetchUserPermissions = createAsyncThunk('permissions/fetchUserPermissions',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchPermissions();
            return process.env.REACT_APP_USELOCALDATA ? response.permissions : response;
        } catch (error) {
            console.error('permissionAttributes error:', error);
            return rejectWithValue(error.message || "Failed to fetch permissions");
        }
    }
);

export const getUserPermissions = (state) => state.permissions.userPermissions;
export const getPermissionsStatus = (state) => state.permissions.status;
export const getPermissionsError = (state) => state.permissions.error;

export default permissionsSlice.reducer